import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const customerNotesApi = createApi({
  reducerPath: "customerNotesApi",
  baseQuery,
  tagTypes: ["customerNotes"],
  endpoints: (builder) => ({
///v1/customer/customer-notes/{CustomerId}/{CustomerNotesId}

    createCustomerNotes: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/customer/customer-notes/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { CustomerNote: data },
      }),
      invalidatesTags: ["customerNotes"],
    }),


    // Updated Export Table

    updateCustomerNotes: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `/customer/customer-notes/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { CustomerNote: data },
      }),
      invalidatesTags: ["customerNotes"],
    }),

    // getNotesByCustomerId: builder.query({
    //   query: ({ id }) => `customer/customer-notes/${id}`,
    //   transformResponse: (response) => {
    //     const data = response?.data ?? [];
    //     const normalized = Array.isArray(data) ? data : [data];
    //     return normalized.map((item) => ({
    //       ...item,
    //       id: item.customerNotesId,
    //     }));
    //   },
    //   providesTags: ["customerNotes"],
    // }),
    getNotesByCustomerId: builder.query({
      query: ({ id }) => `customer/customer-notes/${id}`,
    
      transformResponse: (response) => {
        console.log("🔥 Raw API Response:", response);
    
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];
    
        const finalData = normalized.map((item) => ({
          ...item,
          id: item.customerNotesId,
        }));
    
        console.log("✅ Transformed wowowowowoowowowowoowowoResponse:", finalData);
    
        return finalData;
      },
    
      providesTags: ["customerNotes"],
    }),
    

    // Get single invoice by Id
    getCustomerId: builder.query({
      query: ({ id, subId }) =>
        `customer/customer-notes/${id}/${subId}`,
      transformResponse: (response) => response?.data ?? null,


      providesTags: ["customerNotes"],
    }),

    deleteCustomerNote: builder.mutation({
      query: ({ id }) => ({
        url: `customer/customer-notes/${id}`,
        method: "DELETE",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
      }),
      invalidatesTags: ["customerNotes"],
    }),

    fileUpload: builder.mutation({
      query: ({ file, token }) => {
        const formData = new FormData();
        formData.append("File", file);
        for (let [key, value] of formData.entries()) {
        }
        return {
          url: 'file-upload/upload',
          method: "POST",
          body: formData,
          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
            "Authorization": `Bearer ${token}`,
          },
        };
      },
      invalidatesTags: ["fileUpload"],
    }),
  })
});
export const {
    useCreateCustomerNotesMutation,
    useUpdateCustomerNotesMutation,
    useLazyGetNotesByCustomerIdQuery,
    useDeleteCustomerNoteMutation,
    useFileUploadMutation


 

} = customerNotesApi;


